import { render, staticRenderFns } from "./editStaff.vue?vue&type=template&id=2b556a5c&"
import script from "./editStaff.vue?vue&type=script&lang=js&"
export * from "./editStaff.vue?vue&type=script&lang=js&"
import style0 from "./editStaff.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports